import Pagination from "../../../components/pagination/Pagination";
import connect from "react-redux/es/connect/connect";
import { getLogs } from "../../../redux/actions/logActions";
const mapStateToProps = (state, ownProps) => {
  return {
    page: state.log.page,
    pages: state.log.pages,
    pageSize: state.log.pageSize,
    nbItems: state.log.logs.length
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getNext: page => {
      const nextPage = page;
      dispatch(getLogs({ page: nextPage }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pagination);



// WEBPACK FOOTER //
// src/containers/activite/log/PaginationContainer.js